
import React, { Component, Fragment } from 'react';
import { Input } from 'reactstrap';
import moment from 'moment';
import * as firebase from 'firebase';

class VerifiedPhoneNumbers extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: false,
      phoneNumber: null,
    }
  }

  async componentDidMount() {
    document.title = "Phone Number Lookup";
  }

  formatDateTime (date) {
    if(date){
      return moment(date).format("h:mma, D MMM YYYY")
    } else {
      return '-'
    }
  }

  deleteVerifiedNumber = async () => {
    const result = window.confirm("Are you sure you want to delete this number and unverify this user?");

    if (result) {
      const userId = this.state.phoneNumber.userId;
      const promises = [];
      
      promises.push(
        firebase.database().ref(`/verifiedPhoneNumbers/${this.state.inputPhoneNumber}`).remove(),
        firebase.database().ref(`/users/${userId}/phoneNumber`).remove(),
      );

      await Promise.all(promises);

      window.alert("Number deleted & user unverified");
      window.location.reload();
    }
  }

  handlePhoneNumberChange = (e) => {
    console.log(e);
    this.setState({ inputPhoneNumber: e.target.value });
  }
  
  getPhoneNumber = async () => {
    this.setState({ loading: true });
    const phoneNumber = (await firebase.database().ref(`/verifiedPhoneNumbers/${this.state.inputPhoneNumber}`).once('value')).val();
    console.log(phoneNumber);
    this.setState({ phoneNumber, loading: false });
  }

  render() {
    const noPhoneNumbers = (
      <div className="col-md-10 offset-md-1 card pt-4 pb-4">
        <h3>No phone numbers</h3>
      </div>
    );

    const phoneNumberLookup = (
      <div className="col-md-10 offset-md-1 card">
        <div className="pt-4 pb-4">
          <h2 className="text-center">Lookup Phone Number</h2>
          <p>Tip #1: Try using country code (353) and mobile (08X) prefixes when looking up a number</p>
          <p>Tip #2: Don't use + or other symbols like - etc, just enter the Number</p>
          <br/>

          <Input onChange={this.handlePhoneNumberChange} />
          <br/>

          <button className="btn btn-primary" onClick={this.getPhoneNumber} disabled={this.state.loading}>Get results</button>
          <br/>
        </div>
      </div>
    );

    const phoneNumberViewer = (
      <div className="col-md-10 offset-md-1 card">
        <div className="col-md-12 pt-4 pb-4">
          <h3>Number found</h3>

          { this.state.phoneNumber && this.state.phoneNumber.userId && (
              <p>Bamboo User ID: {this.state.phoneNumber.userId}</p>
          )}
          
          { this.state.phoneNumber && this.state.phoneNumber.verifiedTime && (
              <p>Verified at: {this.formatDateTime(this.state.phoneNumber.verifiedTime)}</p>
          )}

          { this.state.phoneNumber && this.state.phoneNumber.userId && (
            <div>
              <a className="btn btn-primary" href={`/admin/user/${this.state.phoneNumber.userId}`} target="_blank" rel="noopener noreferrer">
                View User in Athena
              </a>
            </div>
          )}

          <br/>

          <div>
            <button className="btn btn-danger" href={`#`} onClick={this.deleteVerifiedNumber}>
              Delete number &amp; unverify user
            </button>
          </div>
        </div>
      </div>
    );

    return (
      <Fragment>
        { phoneNumberLookup }

        <br/>

        {
          this.state.phoneNumber && this.state.phoneNumber.userId
          ? phoneNumberViewer
          : noPhoneNumbers
        }
    </Fragment>
    );
  }
}

export default VerifiedPhoneNumbers;
